import { Extension } from '@tiptap/core';
import { TextSelection, NodeSelection } from 'prosemirror-state';

export const EnterAfterMathBlock = Extension.create({
  name: 'enterAfterMathBlock',

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state, view } = editor;
        const { tr, selection, schema, doc } = state;
        const { $from } = selection;

        const paragraph = schema.nodes.paragraph.create();

        // Case 1: Cursor is directly after a mathBlock
        if ($from.nodeBefore?.type.name === 'mathBlock') {
          const posAfter = $from.pos;
          tr.insert(posAfter, paragraph);
          tr.setSelection(TextSelection.near(tr.doc.resolve(posAfter + 1)));
          view.dispatch(tr);
          return true;
        }

        // Case 2: MathBlock is selected (NodeSelection) and it’s last node
        if (
          selection instanceof NodeSelection &&
          selection.node.type.name === 'mathBlock'
        ) {
          const posAfter = selection.$to.pos;
          tr.insert(posAfter, paragraph);
          tr.setSelection(TextSelection.near(tr.doc.resolve(posAfter + 1)));
          view.dispatch(tr);
          return true;
        }

        // Case 3: MathBlock is the very last node in document
        const lastNode = doc.lastChild;
        if (lastNode?.type.name === 'mathBlock') {
          const posAfter = doc.content.size;
          tr.insert(posAfter, paragraph);
          tr.setSelection(TextSelection.near(tr.doc.resolve(posAfter + 1)));
          view.dispatch(tr);
          return true;
        }

        return false;
      },
    };
  },
});
